module.exports = __webpack_public_path__ + "img/Jennifer_Kasmin.36c91808.jpg";